var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdealAreaBuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1368_3636",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 53,
    height: 53
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1368_3636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0419 45.2707C10.131 45.2707 9.35124 44.9463 8.70254 44.2976C8.05384 43.6489 7.72949 42.8691 7.72949 41.9582H11.0419V45.2707ZM7.72949 37.5416V33.1249H11.0419V37.5416H7.72949ZM7.72949 28.7082V24.2916H11.0419V28.7082H7.72949ZM7.72949 19.8749V15.4582H11.0419V19.8749H7.72949ZM7.72949 11.0416C7.72949 10.1307 8.05384 9.35087 8.70254 8.70217C9.35124 8.05347 10.131 7.72913 11.0419 7.72913V11.0416H7.72949ZM15.4586 45.2707V41.9582H19.8753V45.2707H15.4586ZM15.4586 11.0416V7.72913H19.8753V11.0416H15.4586ZM24.2919 45.2707V41.9582H28.7086V45.2707H24.2919ZM24.2919 11.0416V7.72913H28.7086V11.0416H24.2919ZM33.1253 45.2707V41.9582H37.5419V45.2707H33.1253ZM33.1253 11.0416V7.72913H37.5419V11.0416H33.1253ZM41.9586 45.2707V41.9582H45.2711C45.2711 42.8755 44.9467 43.6569 44.298 44.3024C43.6493 44.9479 42.8695 45.2707 41.9586 45.2707ZM41.9586 37.5416V33.1249H45.2711V37.5416H41.9586ZM41.9586 28.7082V24.2916H45.2711V28.7082H41.9586ZM41.9586 19.8749V15.4582H45.2711V19.8749H41.9586ZM41.9586 11.0416V7.72913C42.8695 7.72913 43.6493 8.05347 44.298 8.70217C44.9467 9.35087 45.2711 10.1307 45.2711 11.0416H41.9586Z",
    fill: "#8675FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdealAreaBuild);
export default __webpack_public_path__ + "static/media/ideal-area-build.b93a33f313194e1f28c92bbb953ba067.svg";
export { ForwardRef as ReactComponent };